import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation, Trans} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';
import {history} from 'core/history';
import {ROUTE} from 'core/routes';
import {$showNoFirsModal, setShowNoFirsModal} from 'models/documents/invoices/common';

import {colors} from 'theme';

import {ButtonWrapper, TextWrapper} from './styled';

export const ModalFirsError = () => {
    const showNoFirsModal = useStore($showNoFirsModal);
    const {t: translation} = useTranslation();
    const GEN_INFO = 'pages.documents.invoices.noFirsModal';
    const t = (key: string, vars?: Record<string, any>) =>
        translation(`${GEN_INFO}.${key}`, vars ?? {});

    function goToProfile() {
        history.push(ROUTE.PROFILE);
        setShowNoFirsModal(false);
    }

    return (
        <Modal
            title={t('title')}
            show={showNoFirsModal}
            modalWidth={0}
            onClose={() => setShowNoFirsModal(false)}
        >
            <TextWrapper>
                <Trans
                    i18nKey={'pages.documents.invoices.noFirsModal.text'}
                    components={{
                        highlight: <span style={{color: colors.brandPrimary}} />,
                    }}
                />
            </TextWrapper>
            <ButtonWrapper>
                <Button
                    type="button"
                    onClick={() => setShowNoFirsModal(false)}
                    variant={ButtonVariant.Outline}
                >
                    {t('cancel')}
                </Button>
                <Button
                    onClick={() => {
                        goToProfile();
                    }}
                    type="button"
                    variant={ButtonVariant.Normal}
                >
                    {t('goToProfile')}
                </Button>
            </ButtonWrapper>
        </Modal>
    );
};
